<template>
    <vs-table 
        multiple
        :data="memberReadData"
        :max-items="itemsPerPage"
        pagination
        :stripe="true"
        v-model="selected"
        search
    >
        <template slot="header">
            <!-- ITEMS PER PAGE -->
            <div class="flex-grow">
                <vs-dropdown vs-trigger-click class="cursor-pointer">
                    <div class="p-4 border border-solid d-theme-border-grey-light rounded-full cursor-pointer flex items-center justify-between font-medium">
                        <span class="mr-2">
                            {{ itemsPerPage }}
                        </span>
                        <feather-icon
                            icon="ChevronDownIcon"
                            svgClasses="h-4 w-4"
                        />
                    </div>
                    <vs-dropdown-menu>
                        <vs-dropdown-item :key="ipp" v-for="ipp in [15,25,50,100]" @click="itemsPerPage = ipp"><span>{{ipp}}</span></vs-dropdown-item>
                    </vs-dropdown-menu>
                </vs-dropdown>
                <vs-button @click="remove" class="mr-2" color="danger" type="filled">Xóa {{selected.length > 0 ? "("+selected.length+")" : ""}}</vs-button>
                <vs-button @click="removeAll" class="mr-2" color="danger" type="filled">Xóa tất cả</vs-button>
            </div>
        </template>
        <template slot="thead">
            <vs-th
                :key="h.field" 
                v-for="h in header"
                :sort-key="h.field"
            >
                {{ h.title }}
            </vs-th>
        </template>
        <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :key="h.field" v-for="h in header" :data="data[indextr][h.field]">
                    <template v-if="h.render">
                        {{ h.render(data[indextr][h.field]) }}
                    </template>
                    <template v-else>
                        {{ data[indextr][h.field] }}
                    </template>
                </vs-td>
            </vs-tr>
        </template>
    </vs-table>
</template>

<script>
import Swal from 'sweetalert2';
import vSelect from 'vue-select';
import moment from 'moment';

export default {
    props: ["date"],
    data(){
        return {
            itemsPerPage: 15,
            header: [ 
                { title:"ID", field:"id" },
                { title:"Thành viên", field:"member_name" },
                { title:"Kiểu gian lận", field:"cheat" },
                { title:"Ngày tạo", field:"created_at", render: function(val){ return moment(val).format("DD-MM-YYYY HH:mm:ss"); } },
                { title:"Ngày update", field:"updated_at", render: function(val){ return moment(val).format("DD-MM-YYYY HH:mm:ss"); } }
            ],
            memberReadData: [],
            selected: []
        }
    },
    components: {
        vSelect
    },
    watch: {
        selected: function(newVal){
            console.log("xxx", newVal);
        }
    },
    methods:{
        fetchMemberRead() {
            let vm = this;
            
            this.$http.get("member_read").then((res) => {
                vm.memberReadData = res.data.data;
            });
        },
        remove(){
            let vm = this;
            let ids = this.selected.map(e => e.id).join(",");
        
            Swal.fire({
                title: '',
                text: "Bạn có chắc chắn muốn xóa "+vm.selected.length+" tài khoản trong danh sách?",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Đồng ý'
            }).then((result) => {
                if (result.isConfirmed) {
                    vm.$http.delete(`member_read/${ids}`)
                        .then(res => {
                            Swal.fire("", "Đã xóa thành công "+res.data.data+" tài khoản đã báo cáo");
                            vm.$emit("removeRead");
                            vm.fetchMemberRead();
                        });
                }
            });
        },
        removeAll(){
            let vm = this;

            Swal.fire({
                title: '',
                text: "Bạn có chắc chắn muốn xóa toàn bộ danh sách?",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Đồng ý'
            }).then((result) => {
                if (result.isConfirmed) {
                    vm.$http.delete('member_read')
                        .then(res => {
                            Swal.fire("", "Đã xóa thành công toàn bộ tài khoản đã báo cáo");
                            vm.$emit("removeRead");
                            vm.fetchMemberRead();
                        });
                }
            });
        }
    },
    created(){
        this.fetchMemberRead();
    }
};
</script>

<style>
.swal2-container{
    z-index: 99999;
}
</style>
